import * as React from 'react';
import {
  useSimulateContract,
  useWriteContract,
  useWaitForTransactionReceipt,
  useAccount,
} from 'wagmi';
import { ConnectButton } from '@rainbow-me/rainbowkit';

export function MintWrite(props) {
  const { isConnected } = useAccount();

  const enabled =
    isConnected &&
    !!props.config?.address &&
    Array.isArray(props.config?.args?.[0]) &&
    props.config.args[0].length > 0;

  const {
    data: simData,
    error: simError,
    isLoading: isSimLoading,
    isError: isSimError,
  } = useSimulateContract({
    address: props.config?.address,
    abi: props.config?.abi,
    functionName: props.config?.functionName,
    args: props.config?.args,
    value: props.config?.value,
    query: { enabled },
  });

  const {
    writeContract,
    data: hash,
    isPending,
    error: writeError,
    reset,
  } = useWriteContract();

  const {
    isLoading: isConfirming,
    isSuccess: isConfirmed,
    error: receiptError,
  } = useWaitForTransactionReceipt({ hash });

  React.useEffect(() => {
    if (isConfirmed) {
      try {
        props.resetCart?.();
      } catch (_e) {}
      reset?.();
    }
  }, [isConfirmed, props, reset]);

  function handleMint() {
    if (!simData?.request) return;
    writeContract(simData.request);
  }

  const cartCount = props.cart?.length || 0;
  const insufficient = isSimError;

  return (
    <>
      {isConnected ? (
        <>
          {isSimLoading && <div>Preparing transaction...</div>}
          {insufficient ? (
            <button className='btn btn-primary' disabled>
              <div>
                <p>Cannot prepare transaction</p>
                <p style={{ display: 'block', fontSize: '0.8em' }}>
                  {simError?.shortMessage ||
                    simError?.message ||
                    'Check your wallet balance / network.'}
                </p>
              </div>
            </button>
          ) : (
            <button
              className='btn btn-primary'
              onClick={handleMint}
              disabled={
                !cartCount || !simData?.request || isPending || isConfirming
              }
            >
              {isPending
                ? 'Confirm in wallet...'
                : isConfirming
                ? 'Minting...'
                : `Cart Total: ${props.eth} ETH || Click Here to continue`}
            </button>
          )}
          {writeError && (
            <div style={{ color: '#c33', padding: '6px' }}>
              Error: {writeError.shortMessage || writeError.message}
            </div>
          )}
          {receiptError && (
            <div style={{ color: '#c33', padding: '6px' }}>
              Receipt error: {receiptError.shortMessage || receiptError.message}
            </div>
          )}
          {hash && (
            <div>
              Tx:{' '}
              <a
                href={`https://etherscan.io/tx/${hash}`}
                target='_blank'
                rel='noopener noreferrer'
              >
                {hash.slice(0, 10)}...{hash.slice(-8)}
              </a>
            </div>
          )}
          {isConfirmed && <div>Transaction Confirmed!</div>}
        </>
      ) : (
        <div className='flex justify-center '>
          <ConnectButton
            label={`Cart Total: ${props.eth} ETH || Connect Wallet to continue`}
          />
        </div>
      )}
    </>
  );
}
